
import Swiper from "swiper";
import { Autoplay } from "swiper/modules";

document.addEventListener('DOMContentLoaded', function() {
    const logoCarousels = document.querySelectorAll('.logos[data-is-carousel="1"]');

    logoCarousels.forEach(container => {
        const swiperContainer = container.querySelector('.swiper');
        const controlButton = container.querySelector('.logos__carousel-control');
        const speed = parseInt(container.dataset.carouselSpeed) || 3000;
        if (!swiperContainer) return;

        // Initialize Swiper
        const swiper = new Swiper(swiperContainer, {
            modules: [Autoplay],
            slidesPerView: 2,
            spaceBetween: 20,
            loop: true,
            centeredSlides: false,
            autoHeight: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: false,
                stopOnLastSlide: false,
                waitForTransition: false
            },
            speed: speed,
            breakpoints: {
                480: {
                    slidesPerView: 3,
                },
                768: {
                    slidesPerView: 'auto',
                    spaceBetween: 80
                },

            }

        });

        // Play/Pause functionality
        if (controlButton) {
            controlButton.addEventListener('click', function() {
                if (swiper.autoplay.running) {
                    swiper.autoplay.stop();
                    controlButton.classList.add('paused');
                } else {
                    swiper.autoplay.start();
                    controlButton.classList.remove('paused');
                }
            });

            // Handle autoplay events
            swiper.on('autoplayStart', function() {
                controlButton.classList.remove('paused');
            });

            swiper.on('autoplayStop', function() {
                controlButton.classList.add('paused');
            });
        }
    });
});
